import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import styled from 'styled-components';

export const ContainerInputs = styled(({ ...all }) => (
  <Grid
    container
    direction="column"
    style={{ maxWidth: `500px`, borderRadius: `10px`, border: `1px solid ${RoutalPalette.neutral10}`, padding: `20px` }}
    {...all}
  />
))``;
